import Vue from "vue";
import VueRouter from "vue-router";
import Journal from "../views/panel/Journal.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import('../views/Home.vue')
  },
  {
    path: "/login/",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Login.vue')
    //   () =>
    // import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/register/",
    name: "Register",
    component: () => import('../views/Register.vue')
  },
  {
    path: "/thankyou/",
    name: "Thankyou",
    component: () => import('../views/Thankyou.vue')
  },
  {
    path: "/confirm/:userId/:token",
    name: "Confirm",
    component: () => import('../views/Confirm.vue')
  },
  {
    path: "/forget/",
    name: "Forget",
    component: () => import('../views/Forget.vue')
  },
  {
    path: "/forget-action/:userId/:token",
    name: "ForgetAction",
    component: () => import('@/views/ForgetAction')
  },
  {
    path: "/journal/",
    name: "Journal",
    component: Journal
  },
  {
    path: "/my-data/",
    name: "MyData",
    component: () => import('../views/panel/MyData.vue')
  },
  {
    path: "/add-account/",
    name: "AddAccount",
    component: () => import('../views/panel/AddAccount')
  },
  {
    path: "/config/",
    name: "Config",
    component: () => import('../views/panel/Config')
  },
  {
    path: "/services/",
    name: "Services",
    component: () => import('../views/panel/Services')
  },
  {
    path: "/staff/",
    name: "Staff",
    component: () => import('../views/panel/Staff')
  },
  {
    path: "/schedule/",
    name: "Schedule",
    component: () => import('../views/panel/Schedule')
  },
  {
    path: "/clients/",
    name: "Clients",
    component: () => import('../views/panel/Clients')
  },
  {
    path: "/support/",
    name: "Support",
    component: () => import('@/views/panel/Support')
  },
  {
    path: "/faq/",
    name: "Faq",
    component: () => import('@/views/panel/Faq')
  },
  {
    path: "/integrate/",
    name: "Integrate",
    component: () => import('@/views/panel/Integrate')
  },
  {
    path: '/statistics/',
    name: 'Statistics',
    component: () => import('@/views/panel/Statistics')
  },
  {
    path: '/calc-salary',
    name: 'CalcSalary',
    component: () => import('@/views/panel/CalcSalary')
  },
  {
    path: "/sms/",
    name: "Sms",
    component: () => import('@/views/panel/Sms')
  },
  {
    path: "/service-work/",
    name: "ServiceWork",
    component: () => import('@/views/ServiceWork')
  },
  {
    path: "/payment/",
    name: "Payment",
    component: () => import('../views/panel/Payment')
  },
  {
    path: "/account/",
    name: "Account",
    component: () => import('../views/panel/Account')
  },
  {
    path: "/*",
    name: "NotFound",
    component: () => import('@/views/NotFound')
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
